import Link from 'next/link';
import React, { Fragment } from 'react';

/** A component that either renders an anchor element or a span, depending on if the href is provided. The anchor
 * will be a NextJS Link element, with an anchor inside. Any class attribute that is provided will either go on the
 * span element or the anchor element
 */
export const OptionalLink: React.FC<
  Omit<React.ComponentProps<typeof Link>, 'href'> & { href?: string } & {
    fallback?: 'div' | 'span' | typeof Fragment;
  }
> = ({ href, children, fallback, ...props }) => {
  if (!href) {
    const FallbackElement = fallback || 'span';
    return (
      <FallbackElement
        {
          // Horrible cast as any because we may be given props for a Link/anchor, but don't need
          // to render an anchor when not given a href
          ...(props as any)
        }
      >
        {children}
      </FallbackElement>
    );
  }

  return (
    <Link href={href}>
      <a {...props}>{children}</a>
    </Link>
  );
};
